import {Grid, Stack} from '@mui/material';
import {AppControlledAutoComplete} from 'components/form';
import {SelectOptionsType} from 'global';
import {useBoardRedux, useWorkSpaceRedux} from 'hooks';
import {useGetAllUsersByBoardId} from 'hooks/useUserApi';
import React, {useEffect, useMemo} from 'react';
import {FieldsRendererProps} from '..';

interface RenderAssignToSelectProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderAssignToSelect: React.FC<RenderAssignToSelectProps> = ({
    field,
    control,
    indexKey,
    setValue,
    watch,
    gridSize,
}) => {
    const {allUsersByBoardIdLoading, allUsersByBoardIdResponse, getAllUsers} = useGetAllUsersByBoardId();
    const {selectedWorkSpace} = useWorkSpaceRedux();
    const {selectedBoard} = useBoardRedux();
    console.log('allUsersByBoardIdResponse', allUsersByBoardIdResponse);

    const parsedUsers = useMemo<SelectOptionsType[]>(() => {
        if (allUsersByBoardIdResponse && !allUsersByBoardIdLoading) {
            return allUsersByBoardIdResponse.map(u => ({
                label: `${u.firstName} ${u.lastName}`,
                value: u.id,
            }));
        }
        return [];
    }, [allUsersByBoardIdResponse, allUsersByBoardIdLoading]);

    // 2) When parsedUsers changes, set the form default
    useEffect(() => {
        if (parsedUsers.length > 0) {
            setValue(`data.${indexKey}.defaultValue.options`, parsedUsers, {
                shouldDirty: false,
                shouldTouch: false,
            });
        }
    }, [parsedUsers, indexKey]);
    useEffect(() => {
        if (field.value.selectedOption) {
            setValue(`data.${indexKey}.value.selectedOption`, field.value.selectedOption);
        }
    }, [field.value.selectedOption]);

    // 3) Trigger the fetch when board/workspace changes
    useEffect(() => {
        if (selectedBoard?.id && selectedWorkSpace?.id) {
            getAllUsers({
                variables: {
                    filter: {
                        boardId: selectedBoard.id,
                        workspaceId: selectedWorkSpace.id,
                    },
                },
            });
        }
    }, [selectedBoard, selectedWorkSpace, getAllUsers]);

    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledAutoComplete
                    label={field.title}
                    loading={allUsersByBoardIdLoading}
                    required={field.isRequired}
                    defaultValue={field.value.selectedOption}
                    control={control}
                    name={`data.${indexKey}.value.selectedOption`}
                    options={parsedUsers}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                />
            </Stack>
        </Grid>
    );
};

export default RenderAssignToSelect;
